import { useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import { getPlayLinkByBrand, trackRegisterClickByBrand } from '../../config/playLinks';

const reviewCompanies = [
  { name: 'MrBoom9', logo: '/casino-logo/mrboom9.png', trustpilotUrl: 'https://www.trustpilot.com/review/mrboom9.pro' },
  { name: 'iPay9', logo: '/casino-logo/ipay9.png', trustpilotUrl: 'https://www.trustpilot.com/review/www.ipay9.net' },
  { name: 'Kingbet9', logo: '/casino-logo/kingbet9.png', trustpilotUrl: 'https://www.trustpilot.com/review/kb9au.com' },
  { name: 'Me99', logo: '/casino-logo/me99.png', trustpilotUrl: 'https://www.trustpilot.com/review/me99aus.net' },
  { name: 'BigPay77', logo: '/casino-logo/bp77.png', trustpilotUrl: 'https://www.trustpilot.com/review/bigpay77aus.com' },
  { name: 'Gucci9', logo: '/casino-logo/gucci9.png', trustpilotUrl: 'https://www.trustpilot.com/review/gucci9-rd.connectn.workers.dev' },
  { name: 'Spinaroo', logo: '/casino-logo/spinaroo.png', trustpilotUrl: 'https://www.trustpilot.com/review/spinaroo-rd.connectn.workers.dev' },
  { name: 'Rolex9', logo: '/casino-logo/rolex9.png', trustpilotUrl: 'https://www.trustpilot.com/review/rolex9.net' },
  { name: 'MrBean9', logo: '/casino-logo/mrbean9.png', trustpilotUrl: 'https://www.trustpilot.com/review/mrbean9.com' },
  { name: 'Bybid9', logo: '/casino-logo/bybid9.png', trustpilotUrl: 'https://www.trustpilot.com/review/bybid9.net' },
  { name: 'Winnie777', logo: '/casino-logo/winnie777.png', trustpilotUrl: 'https://www.trustpilot.com/review/winnie777.co' },
  { name: 'Micky9', logo: '/casino-logo/micky9.png', trustpilotUrl: 'https://www.trustpilot.com/review/micky9.com' },
  { name: 'Queen13', logo: '/casino-logo/queen13.png', trustpilotUrl: 'https://www.trustpilot.com/review/queen13au.com' },
];

const chooseCasinoTips = [
  {
    title: 'Do your research',
    text: "It's always a good idea to read a few online casino reviews before making your choice, to compare what different casinos have to offer. You can also check our list of sites to avoid, to find out about particularly dangerous or untrustworthy casinos.",
  },
  {
    title: "Make sure it's available in your country",
    text: "Not all online casinos accept players from everywhere in the world. Even if they do, they may not offer support that's particularly suitable for every country. Get in touch with customer service before joining if you're unsure.",
  },
  {
    title: 'Test the free games',
    text: "Many casinos offer free games that you can try without having to create an account. This is a great way to get a feel for some of their games and see if you like them before depositing any real money.",
  },
  {
    title: 'Understand bonus requirements',
    text: "More often than not, the bigger the bonus, the better it is. While this may be true, you need to examine the bonus wagering requirements too. It's important to know how much you need to play through in order to claim your winnings.",
  },
  {
    title: 'Check the payout speed',
    text: "There's nothing worse than winning a huge jackpot and then sitting and waiting for weeks or even months before you can claim it. You'll want an online casino with a fast payout time.",
  },
];

const faqItems = [
  {
    question: 'What is the most trusted online casino?',
    answer:
      'The most trusted online casinos are those licensed by reputable authorities (e.g. Curacao Gaming Authority (CGA), or PAGCOR, use SSL encryption, have clear terms and conditions, and are regularly audited by independent bodies like eCOGRA. We recommend checking our reviews and comparing safety scores before signing up.',
  },
  {
    question: 'How do I know if a casino site is legit?',
    answer:
      'Look for valid licensing from recognised regulators, SSL encryption (https), clear contact information, transparent bonus terms, and positive reviews from independent sources. Avoid sites with no licence, unclear ownership, or unrealistic bonus promises.',
  },
  {
    question: 'Who writes the casino reviews at KoalaBet?',
    answer:
      'Our casino reviews are written by experienced editors and researchers who test platforms, compare bonuses, verify licences, and assess customer support. We aim to provide honest, up-to-date information to help you choose a safe and enjoyable casino.',
  },
];

const topRatedReviewCards = [
  {
    rank: 1,
    name: 'iPay9',
    logo: '/casino-logo/ipay9.png',
    bonus: 'Up to 100% Welcome Bonus',
    payout: '1-2 days',
    winRate: '97%',
  },
  {
    rank: 2,
    name: 'Kingbet9',
    logo: '/casino-logo/kingbet9.png',
    bonus: 'Daily Easy Tasks Get $100',
    payout: '1-3 days',
    winRate: '95%',
  },
  {
    rank: 3,
    name: 'Me99',
    logo: '/casino-logo/me99.png',
    bonus: 'Up to A$220.99 Starter Pack',
    payout: '1-3 days',
    winRate: '92%',
  },
  {
    rank: 4,
    name: 'Spinaroo',
    logo: '/casino-logo/spinaroo.png',
    bonus: 'Up to A$199.99 + 80% Welcome Bonus',
    payout: '1-3 days',
    winRate: '91%',
  },
];

/**
 * Styled Trustpilot-style link only — do NOT use class "trustpilot-widget" or Trustpilot
 * data-* attributes here. The global tp.widget.bootstrap script would hijack the DOM and
 * replace hrefs with whatever business unit is tied to that snippet (e.g. wrong site after refresh).
 */
function TrustpilotWidget({ url }: { url: string }) {
  return (
    <div className="w-full">
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center gap-2 w-full min-h-[48px] px-4 py-3 rounded-lg bg-white border-2 border-[#00b67a] text-gray-900 no-underline hover:bg-[#f8fdf9] hover:border-[#00a36a] active:scale-[0.98] transition-all"
      >
        <span className="text-sm font-medium">Review us on</span>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="#00b67a" className="flex-shrink-0" aria-hidden>
          <path d="M12 0l3.09 6.26L22 7.27l-5 4.87 1.18 6.88L12 16.77l-6.18 3.25L7 12.14 2 7.27l6.91-1.01L12 0z" />
        </svg>
        <span className="text-sm font-semibold">Trustpilot</span>
      </a>
    </div>
  );
}

export default function PlayerReviews() {
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);

  return (
    <div className="min-h-screen bg-[#f5f5f7]">
      <Navbar />

      {/* Hero */}
      <section className="relative min-h-[320px] overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: "url('/images/review-hero-bg.png')" }}
        />
        <div className="absolute inset-0 bg-white/10" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-12">
          <div className="flex items-center space-x-2 text-sm text-black/90 mb-4">
            <a href="/" className="hover:text-gray-700 transition-colors">
              Home
            </a>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-black">Player Reviews</span>
          </div>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-black">Player Reviews</h1>
          <p className="text-black/95 max-w-3xl leading-relaxed">
            Our team of experts personally test and review each site on our shortlist. We rank online casinos against seven key categories including security and licensing, game variety, bonuses and promotions, and customer support. Find out more about how we rate casinos, and find the best options for you below! See what real players say about our recommended casinos. Click any Trustpilot widget to view reviews.
          </p>
        </div>
      </section>

      {/* Companies with Trustpilot Widget */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">All Companies</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {reviewCompanies.map((company) => (
            <div
              key={company.name}
              className="rounded-xl bg-white border border-gray-200 overflow-hidden shadow-sm hover:shadow-md hover:border-purple-200 transition-all"
            >
              <div className="p-5 flex flex-col items-center text-center">
                <div className="w-20 h-20 rounded-xl border border-gray-200 flex items-center justify-center overflow-hidden bg-white mb-4">
                  <img src={company.logo} alt={company.name} className="w-full h-full object-contain" />
                </div>
                <h3 className="font-bold text-gray-900 text-lg mb-4">{company.name}</h3>
                <div className="w-full">
                  <TrustpilotWidget url={company.trustpilotUrl} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-6 pb-8">
        <h2 className="text-2xl sm:text-3xl text-center font-semibold text-gray-900 mb-5">Our reviewers&apos; top rated online casinos</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {topRatedReviewCards.map((card) => (
            <article
              key={card.name}
              className="group rounded-xl border border-gray-200 bg-white overflow-hidden shadow-[0_1px_3px_rgba(0,0,0,0.05)] hover:shadow-[0_4px_14px_rgba(0,0,0,0.08)] transition-shadow duration-200"
            >
              <div className="relative bg-gradient-to-r from-[#5a22c8] to-[#7a37e7]">
                <span className="absolute left-0 top-0 rounded-br-lg bg-[#ece8ff] px-3 py-1.5 text-md font-semibold text-[#3a1aa0]">
                  {card.rank}
                </span>
                {card.rank === 1 && (
                  <span className="absolute right-2.5 top-2.5 rounded-full bg-[#a91eff] px-2.5 py-1 text-base font-medium text-white backdrop-blur-sm">
                    Top Rated
                  </span>
                )}
                <div className="h-40 flex items-center justify-center">
                    <img src={card.logo} alt={card.name} className="h-full w-full object-cover" />
                </div>
              </div>

              <div className="p-5 text-center">
                <h3 className="text-xl sm:text-2xl leading-none font-bold text-[#35178f] mb-1">{card.name}</h3>
                <p className="text-sm font-medium text-gray-700 mb-4">{card.bonus}</p>
                <a
                  href={getPlayLinkByBrand(card.name)}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackRegisterClickByBrand(card.name)}
                  className="inline-flex items-center justify-center gap-2 w-full h-11 rounded-lg bg-gradient-to-r from-[#4315d6] to-[#5b22ee] hover:from-[#3710bc] hover:to-[#4b1bcf] text-white text-base sm:text-lg font-semibold transition-colors"
                >
                  Play Now
                  <i className="ri-arrow-right-line text-base opacity-80 group-hover:translate-x-0.5 transition-transform"></i>
                </a>

                <div className="mt-5 grid grid-cols-2 gap-3 border-t border-gray-100 pt-4">
                  <div>
                    <p className="text-xs text-gray-500 mb-1">Payout</p>
                    <p className="text-lg font-semibold text-gray-900">{card.payout}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500 mb-1">Win Rate</p>
                    <p className="text-lg font-semibold text-[#0f9b65]">{card.winRate}</p>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* How to choose casino - 5 tips */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
        <div className="bg-white rounded-2xl border border-gray-200 p-8 md:p-10 shadow-sm">
          <h2 className="text-2xl font-bold text-gray-900 mb-8">
            How do I choose the right casino? KoalaBet share our top 5 tips
          </h2>
          <div className="space-y-8">
            {chooseCasinoTips.map((tip, idx) => (
              <div key={idx} className="flex flex-col sm:flex-row gap-4 sm:gap-6">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-purple-100 flex items-center justify-center">
                  <span className="text-lg font-bold text-purple-700">{idx + 1}</span>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{tip.title}</h3>
                  <p className="text-gray-700 leading-relaxed">{tip.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 pb-16">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">FAQs</h2>
        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className={`border-b border-gray-100 last:border-b-0 ${openFaqIndex === idx ? 'bg-gray-50' : ''}`}
            >
              <button
                type="button"
                onClick={() => setOpenFaqIndex(openFaqIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-4 sm:px-6 py-4 text-left hover:bg-gray-50/50 transition-colors"
              >
                <span className="font-medium text-gray-900 pr-4">{item.question}</span>
                <i
                  className={`ri-arrow-down-s-line text-xl text-gray-500 flex-shrink-0 transition-transform ${
                    openFaqIndex === idx ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openFaqIndex === idx && (
                <div className="px-4 sm:px-6 pb-4">
                  <p className="text-gray-700 leading-relaxed">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}
